<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  // mixins: [mixins.reactiveProp],
  props: {
    nums: {
      type: [Array, Object],
      default: () => {
        return [1, 1, 1];
      }
    },
    abbr: {
      type: String,
      default: "XX"
    },
    dark: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  data: function() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        events: [],
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        elements: {
          arc: {
            backgroundColor: () => {
              if (this.dark) {
                return ["#0091ff", "#66bdff", "#f1f1f2"];
              } else {
                return ["#0091ff", "#66bdff", "#CFD2D3"];
              }
            },
            borderWidth: 0
          }
        },
        cutoutPercentage: 66
      }
    };
  },
  computed: {
    chartableRing() {
      return {
        datasets: [this.nums]
      };
    }
  },
  mounted() {
    this.renderChart(this.chartableRing, this.options);
  }
};
</script>
